import i18n from 'helper/i18n';
import { PoolClusterType, PoolEnumType } from 'types/services/magnolia/enums/PoolEnum';

export const POOL_TYPE: { [key: string]: PoolEnumType } = {
	WORKOUT: 'workout',
	RECIPE: 'recipe',
};

export const POOL_CLUSTER: { [key: string]: PoolClusterType } = {
	ALL: 'all',
	FAVORITE: 'favorite',
	CUSTOM: 'custom',
};

export const mapClusterURLToID: { [key: string]: PoolClusterType } = {
	[i18n(`react.impulsCoach.routes.pool.cluster.${POOL_CLUSTER.ALL}.href`)]: POOL_CLUSTER.ALL,
	[i18n(`react.impulsCoach.routes.pool.cluster.${POOL_CLUSTER.FAVORITE}.href`)]: POOL_CLUSTER.FAVORITE,
	[i18n(`react.impulsCoach.routes.pool.cluster.${POOL_CLUSTER.CUSTOM}.href`)]: POOL_CLUSTER.CUSTOM,
};

export const mapSelectedPoolURLToID: { [key: string]: PoolEnumType } = {
	[i18n(`react.impulsCoach.routes.pool.selectedPool.${POOL_TYPE.WORKOUT}.href`)]: POOL_TYPE.WORKOUT,
	[i18n(`react.impulsCoach.routes.pool.selectedPool.${POOL_TYPE.RECIPE}.href`)]: POOL_TYPE.RECIPE,
};
